module.exports = __webpack_public_path__ + "static/media/accept_blue.0c0f5e98.png";